<template>
      <mdb-container>
        <div style="padding-top: 125px;"></div>
        <mdb-card class="mb-4 text-left">
          <mdb-card-header class="secondary-color">
            Topics
          </mdb-card-header>
          <mdb-card-body class="mb-4">
            <mdb-row v-if="topics.length>0">
              <div :key="i" class="col-md-3 d-flex align-self-stretch mb-4" v-for="(t,i) in topics">
                <mdb-col class="text-center"><a @click.prevent="showTopic(t)" href="">{{t.name}}</a></mdb-col>
              </div>
            </mdb-row>
          </mdb-card-body>

        </mdb-card>
      </mdb-container>
</template>

<script>
import api from '../services/groupsPlaceApi.js'
import groupCard from './group/Card'
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardGroup,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbView,
} from 'mdbvue';

export default {
    name: 'Explore',
    components: {
      mdbContainer,
      mdbCard,
      mdbCardHeader,
      mdbCardGroup,
      mdbCardBody,
      mdbCardTitle,
      mdbCardText,
      mdbRow,
      mdbCol,
      mdbMask,
      mdbCardImage,
      mdbView,
      mdbBadge,
      mdbBtn,
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      mdbInput,
      groupCard
    },
    data() {
      return {
        topics: [],
        offset: 0,
      }
    },
    mounted() {
      this.loadData()
    },
    methods: {
      showTopic(t) {
        this.$router.push("/topic/"+t.uriPathName)
      },
      loadData() {
        this.$store.dispatch("setExecuting", false)
        let url = "/public/topics/"
        api.get(url).then(
          (results) => {

            this.topics = results.data
          },
          (error) => {
            this.$notify.error({message: "Error fetching page.", timeOut: 5000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })

      }
    }

  };
</script>
<style scoped>

</style>
